var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "search-input uk-inline",
    class: {
      'search-input--clearable': _vm.allowClear
    }
  }, [_c('span', {
    staticClass: "uk-form-icon"
  }, [_c('icon', {
    attrs: {
      "name": "search"
    }
  })], 1), _vm._v(" "), _c('input', {
    ref: "primaryInput",
    staticClass: "search-input__input uk-input",
    attrs: {
      "type": "search",
      "placeholder": _vm.placeholderOrDefault,
      "disabled": _vm.disabled
    },
    domProps: {
      "value": _vm.query
    },
    on: {
      "input": _vm.onInput
    }
  }), _vm._v(" "), (_vm.allowClear) ? _c('a', {
    staticClass: "search-input__clear uk-form-icon uk-form-icon-flip",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.clearAndFocus($event)
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "close"
    }
  })], 1) : _vm._e()])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7b508857","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/SearchInput.vue
// module id = 2070
// module chunks = 0